import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import {
  AgxBadge,
  BadgeColor,
  formatDate,
  getDateStatus,
} from '@urbanx/agx.ui-components2'

interface TaskDueCellProps {
  task: AutopilotTaskDto
}

const TaskDueCell = ({ task }: TaskDueCellProps) => {
  const { dueDate } = task

  const dueDateStr = dueDate as unknown as string

  if (!dueDateStr) return null

  const status = getDateStatus(dueDateStr ?? '')
  const isHighlighted = ['Today', 'Overdue'].includes(status)
  const badgeColor = (status === 'Overdue' ? 'red' : 'yellow') as BadgeColor

  if (status === 'Invalid date') {
    return (
      <AgxBadge type="colourfill" colour="red" size="md" text="Invalid date" />
    )
  }

  const badgeText = `Due ${formatDate(dueDateStr ?? '', false)}`

  if (isHighlighted) {
    return (
      <AgxBadge
        type="highlighted"
        colour={badgeColor}
        size="md"
        text={badgeText}
        highlightText={status}
      />
    )
  }

  return (
    <AgxBadge
      type="colourfill"
      colour={badgeColor}
      size="md"
      text={badgeText}
    />
  )
}

export default TaskDueCell
